/*
 * trpc (client)
 */
import { supabase } from "@psychology/auth/client"
import type { AppRouter } from "@psychology/trpc/client"
import { httpBatchLink } from "@trpc/client"
import { createTRPCReact } from "@trpc/react-query"
import superjson from "superjson"

export const trpc = createTRPCReact<AppRouter>()

function getApiOrigin() {
	let domain = process.env.API_DOMAIN
	if (domain) {
		return domain
	}

	domain = window.location.origin
	if (!domain.includes("https")) {
		domain = domain.replace(
			process.env.APP_PORT || "3000",
			process.env.API_PORT || "5000",
		)
	}
	return domain
}

async function getAuthToken(): Promise<string | null> {
	const {
		data: { session },
	} = await supabase.auth.getSession()
	return session?.access_token || null
}

export const trpcClient = trpc.createClient({
	links: [
		httpBatchLink({
			url: `${getApiOrigin()}/api/v1/trpc`,
			transformer: superjson,
			methodOverride: "POST",
			async headers() {
				const token = await getAuthToken()
				return {
					authorization: token ? `Bearer ${token}` : "",
				}
			},
			maxURLLength: 2083,
		}),
	],
})
